var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoIconinline = function SvgInfoIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 15 16"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 8,
    r: 7.5,
    fill: "#333332"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.913 3.908a.9.9 0 0 0-.603.225.73.73 0 0 0-.25.542c0 .204.09.399.25.543.16.143.376.224.603.224s.442-.08.602-.224a.73.73 0 0 0 .25-.543.73.73 0 0 0-.25-.542.9.9 0 0 0-.602-.225m-.205 2.44c-.676.05-2.523 1.375-2.523 1.375-.113.077-.08.072.012.215.09.138.08.148.187.082.114-.067.301-.174.614-.348 1.204-.696.193.91-.324 3.615-.205 1.34 1.136.65 1.483.445.34-.2 1.256-.767 1.346-.823.125-.077.035-.138-.062-.266-.068-.087-.136-.026-.136-.026-.37.22-1.046.68-1.137.389-.108-.292.585-2.291.966-3.667.063-.327.233-1.043-.426-.992"
  })));
};
export default SvgInfoIconinline;